import {
	Component, Input, ViewChild, OnInit, OnDestroy, AfterViewInit, OnChanges, SimpleChanges, ElementRef,
	ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Output
} from '@angular/core';
import { TopoMapControl, TopoMapControlListener } from '../../topology/TopoMapControl';
import { MapConversionService } from '../../services/mapconversion.service';
import { TopoMap } from '../../dtos/topology/TopoMap';
import { DeviceLink } from '../../dtos/topology/DeviceLink';
import * as core from 'DiscoveryEngine.TS/Topology';
import { DiscResultsService } from 'discovery';
import { IdentityService } from 'identity';
import { NavigationService } from 'netview';
import { UserSettingsService } from 'main/services/user-settings.service';
import { Theme } from 'main/enums/theme.enum';


@Component({
	selector: 'device-layer2map',
	templateUrl: './device-layer2map.component.html',
	styleUrls: ['./device-layer2map.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceLayer2MapComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges, TopoMapControlListener {

	@Input()
	public deviceGuid: string;

	@Input()
	public isMasterDevice: boolean = false;

	@Input()
	public show: boolean;

	private topoMapControl: TopoMapControl;
	private mapContainer: HTMLDivElement;

	constructor(private element: ElementRef,
		private mapConversionService: MapConversionService,
		private discResultsService: DiscResultsService,
		private identityService: IdentityService,
		private navService: NavigationService,
		private userSettingsService: UserSettingsService,
		private changeDetector: ChangeDetectorRef) {

	}

	public ngOnInit(): void {
		return;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (this.topoMapControl) {
			if (this.show) {
				if (this.isEmptyMap(this.topoMapControl.getMap())) {
					this.loadMap();
				}
			}
			else {
				this.topoMapControl.setMap(this.emptyMap(), false);
			}
		}
	}

	private emptyMap(): TopoMap {
		return this.mapConversionService.convertMap(new core.TopoMap(), new core.DrawSettings());
	}

	private isEmptyMap(map: TopoMap): boolean {
		return (!map || !map.deviceNodes || map.deviceNodes.length == 0);
	}

	public ngOnDestroy(): void {

	}

	private loadMap(): void {
		this.topoMapControl.setMap(this.emptyMap(), false);

		if (!!this.deviceGuid) {
			if (this.isMasterDevice) {
				this.discResultsService.getMasterDeviceTopoMap(this.deviceGuid).subscribe(
					(result: TopoMap) => {
						this.topoMapControl.setMap(result, false);
						this.topoMapControl.fitAndCenter();
					},
					(error) => {
						console.error("Could not get master device topo map: " + this.deviceGuid);
					}
				);
			}
			else {
				let sessionGuid = this.identityService.sessionGuid;
				let netViewGuid = this.navService.location.netViewGuid;
				let agentGuid = this.navService.location.agentGuid;
				let schedDiscGuid = this.navService.location.schedDiscGuid;
				let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

				this.discResultsService.getDeviceTopoMap(sessionGuid, netViewGuid, agentGuid, schedDiscGuid,
					schedDiscRsltGuid, this.deviceGuid).subscribe(
						(result: TopoMap) => {
							this.topoMapControl.setMap(result, false);
							this.topoMapControl.fitAndCenter();
						},
						(error) => {
							console.error("Could not get device topo map: " + this.deviceGuid);
						}
					);
			}
		}
	}

	public ngAfterViewInit(): void {
		let rootElem = <HTMLDivElement>this.element.nativeElement;
		this.mapContainer = <HTMLDivElement>rootElem.querySelector('.device-layer2map-map-container');
		this.topoMapControl = new TopoMapControl(this.mapContainer, this, {
			isDarkTheme: /*this.userSettingsService?.CurrentTheme === Theme.Dark*/ false,
		});
	}

	public onResize(entries: any): void {
		if (this.topoMapControl) {
			let newDialogHeight = entries[0].contentRect.height;
			let newMapHeight = Math.floor(newDialogHeight - 200);
			this.mapContainer.setAttribute('style', `height: ${newMapHeight}px`);
			this.mapContainer.parentElement.setAttribute('style', `height: ${newMapHeight}px`);
			if (this.topoMapControl.hasMap()) {
				this.topoMapControl.fitAndCenter();
			}
		}
	}

	public onDeviceDoubleClick(deviceGuid: string): void {
	}

	onDeviceGroupDoubleClick(deviceGroupGuid: string): void {
	}

	public onLinkDoubleClick(links: DeviceLink[]): void {

	}

	public onMapDoubleClick(): void {

	}

	public onMoveNode(nodeId: number, newX: number, newY: number): void {

	}

	public onContextMenu(targetType: string, targets: any[], ev: MouseEvent): void {

	}

}
